import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';

function DefaultRoute() {
    const location = useLocation()

    return (
        <Route>
            <Redirect to={location.pathname} />
        </Route>
    );
}

export default DefaultRoute;
